<template>
  <div>
    <v-col>
      <div class="text-h4">Do you have a requested due date?</div>
      <v-radio-group v-model="formData.has_due_date">
        <template v-slot:label>
          <div>
            Please Let us know if you have a <strong>Requested Due Date</strong>.
            <MoreInfoToolTip
              msg="123NET project managers will attempt to meet your date,
                  however this is only a request and not guaranteed."
            />
          </div>
        </template>
        <v-radio value='y'>
          <template v-slot:label>
            <div>Yes, I do have a requested due date</div>
          </template>
        </v-radio>

        <v-row v-if="formData.has_due_date === 'y'" class="pa-6">
          <VDateField
            label="Requested Due Date"
            hint="123NET will do its best to accomodate this date"
            persistent-hint
            v-model="formData.requested_due_date"
          />
        </v-row>

        <v-radio value='n'>
          <template v-slot:label>
            <div>No, I do not have a requested due date</div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VDateField from '@/components/formfields/VDateField.vue';
import MoreInfoToolTip from '@/components/menus/MoreInfoToolTip.vue';

export default {
  name: 'RequestedDueDate',
  components: { MoreInfoToolTip, VDateField },
  data: () => ({
    valid: true,
    formData: {
      has_due_date: '',
      requested_due_date: '',
    },
    menu: false,
  }),
  mounted() {
    // set store form data
    const generalData = this.getFormData.general;
    this.formData = {
      has_due_date: generalData.has_due_date || 'n', // if !has_due_date set default to 'n'
      requested_due_date: generalData.requested_due_date,
    };
  },
  computed: {
    ...mapGetters(['getFormData']),
  },
  methods: {
    ...mapActions(['updateStoreFormData']),
    registerFormChange(val) {
      if (this.valid) {
        this.updateStoreFormData({
          data: val.requested_due_date,
          main: 'general',
          sub: 'requested_due_date',
        });
        this.updateStoreFormData({
          data: val.has_due_date,
          main: 'general',
          sub: 'has_due_date',
        });
      }
    },
  },
  watch: {
    formData: {
      handler(val) {
        this.registerFormChange(val);
      },
      deep: true,
    },
  },
};
</script>
